import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      userId: null,
      user: null,
      role: null,
      location: null,
      isLoggingOut: false,
      
      setRole: (role) => set({ role }),
      setLocation: (location) => set({ location }),
      
      login: (userData) => {
        const currentRole = get().role;
        set({ 
          userId: userData._id, 
          user: userData, 
          role: currentRole || userData.accountRole,
          isLoggingOut: false,
        });
      },
      
      logout: () => {
        // Set logout flag FIRST
        set({ isLoggingOut: true });
        
        // Clear localStorage
        try {
          localStorage.removeItem('token');
        } catch (e) {
          console.error('Failed to clear persisted state:', e);
        }
        
        // Clear state
        set({ 
          userId: null, 
          user: null, 
          role: null, 
          location: null,
          isLoggingOut: true,
        }, true);
      },
      
      updateUser: (updates) => set((state) => ({ 
        user: { ...state.user, ...updates },
      })),
    }),
    {
      name: 'token',
      getStorage: () => localStorage,
      partialize: (state) => ({ 
        userId: state.userId, 
        location: state.location, 
        role: state.role,
      }),
    }
  )
);